import React, { useState, useRef } from 'react';
import './body.css';
import { useTranslation } from "react-i18next";

const Body = () => {
    const [t, i18n] = useTranslation("actividad");
    const [responses, setResponses] = useState({});
    const [apiResponse, setApiResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formVisible, setFormVisible] = useState(true); // Estado para controlar la visibilidad del formulario
    const [instructionVisible, setInstructionVisible] = useState(true); // Estado para controlar la visibilidad de la instrucción
    const [nombre, setNombre] = useState(""); // Estado para el campo nombre
    const [correo, setCorreo] = useState(""); // Estado para el campo correo

    const anchorRef = useRef(null); // Referencia para el elemento ancla

    const questions = [
        "¿Qué piensas sobre la libertad?",
        "¿Cuál es la importancia de la libertad para el progreso?",
        "Desde la perspectiva de Ricardo, ¿por qué consideras que es más relevante enfocarse en acabar con la pobreza en lugar de eliminar la desigualdad?",
        "¿Cuál es la forma más eficiente de acabar con la pobreza?",
        "¿Cuál consideras que es una característica esencial de los emprendedores?",
        "¿Qué implica el liderazgo?",
        "¿Cuál es tu opinión sobre el papel de la competencia y cómo esto beneficia a la sociedad?",
        "¿Qué pilar de la prosperidad incluyente es más importante para ti?",
        "¿Cuál es el ciclo virtuoso de la prosperidad?",
        "¿Qué libro ha influido significativamente en tu perspectiva sobre el éxito? (Escribe el libro y el autor)"
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setResponses({
            ...responses,
            [name]: value
        });
    };

    const countWords = (text) => {
        return text.trim().split(/\s+/).length;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar que los campos de nombre y correo no estén vacíos
        if (!nombre.trim()) {
            alert("El campo de nombre no puede estar vacío.");
            return;
        }
        if (!correo.trim()) {
            alert("El campo de correo no puede estar vacío.");
            return;
        }

        // Validar que todas las respuestas tengan al menos 8 palabras, excepto la pregunta 10 que requiere al menos 4 palabras
        for (let i = 1; i <= 10; i++) {
            const response = responses[`A0${i}`];
            const minWords = i === 10 ? 4 : 8;
            if (!response || countWords(response) < minWords) {
                alert(`La pregunta ${i} debe tener al menos ${minWords} palabras.`);
                return;
            }
        }

        setFormVisible(false); // Ocultar el formulario
        setInstructionVisible(false); // Ocultar la instrucción
        setLoading(true); // Iniciar el estado de carga

        const targetDiv = document.getElementById('ancla-act');
        targetDiv.scrollIntoView({ behavior: 'smooth' });

        const requestBody = {
            "A01": responses.A01 || "",
            "A02": responses.A02 || "",
            "A03": responses.A03 || "",
            "A04": responses.A04 || "",
            "A05": responses.A05 || "",
            "A06": responses.A06 || "",
            "A07": responses.A07 || "",
            "A08": responses.A08 || "",
            "A09": responses.A09 || "",
            "A10": responses.A010 || ""
        };

        try {
            // Primer API: Obtener datos
            const response = await fetch('https://dinamicars.algoverse.ai/model/v1/chatbot', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa('usuario2:pass1')
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const data = await response.json();
                setApiResponse(data);

                // Preparar el cuerpo para la segunda API
                const secondApiBody = {
                    preguntas: "PRUEBA 6",
                    respuestas: Object.values(requestBody).join("||"),
                    tipo: "tipo1",
                    porcentaje: data.data.porcentaje_de_rs,
                    nombre: nombre,
                    correo: correo
                };

                // Segunda API: Guardar datos
                const secondResponse = await fetch('https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/quiz/new', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(secondApiBody)
                });

                if (!secondResponse.ok) {
                    console.error('Error en la respuesta de la segunda API:', secondResponse.statusText);
                }
            } else {
                console.error('Error en la respuesta de la primera API:', response.statusText);
            }
        } catch (error) {
            console.error('Error al enviar los datos:', error);
        } finally {
            setLoading(false); // Detener el estado de carga
            anchorRef.current.scrollIntoView({ behavior: 'smooth' }); // Desplazar hacia el componente Body

        }
    };

    const extractVariable = (link) => {
        if (link.includes("GUID=")) {
            return "https://www.ricardosalinas.com/blog/images/imgblog.jpg";
        } else if (link.includes("/blog/")) {
            return "https://www.ricardosalinas.com/blog/images/imgblog.jpg";
        } else if (link.includes("watch?v=")) {
            return "https://www.ricardosalinas.com/blog/images/imgvideo.jpg";
        } else if (link.includes("shorts/")) {
            return "https://www.ricardosalinas.com/blog/images/imgvideo.jpg";
        } else {
            return "Formato no reconocido";
        }
    };

    return (
        <div id="ancla-act" className="Act_body" ref={anchorRef}>
            <div className="Act_content">

                {instructionVisible && (
                    <>
                        <div className="nombre-correo">
                            <h3>Participante:</h3>
                            <div className='nombre'>
                                <label>Nombre:</label>
                                <input
                                    type="text"
                                    name="nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </div>
                            <div className='correo'>
                                <label>Correo:</label>
                                <input
                                    type="email"
                                    name="correo"
                                    value={correo}
                                    onChange={(e) => setCorreo(e.target.value)}
                                />
                            </div>
                        </div>
                        <h3>Contesta las siguientes preguntas con mínimo 8 palabras (excepto la pregunta 10 que requiere al menos 4 palabras):</h3>
                    </>
                )}
                {formVisible && (
                    <form className='form_quizz' onSubmit={handleSubmit}>
                        {questions.map((question, index) => (
                            <div key={index}>
                                <p className='txtlabel'>{index + 1}.- {question}</p>
                                <textarea
                                    type="text"
                                    className='txtquest'
                                    name={`A0${index + 1}`}
                                    onChange={handleChange}
                                />
                            </div>
                        ))}
                        <button className='btn_quizz' type="submit">Enviar</button>
                    </form>
                )}
                {loading ? (
                    <>
                        <div className='act-loading'>
                            <p>Cargando...</p>
                            <img src='https://www.ricardosalinas.com/blog/images/Loading_icon.gif' alt="Loading icon" />
                        </div>
                    </>
                ) : (
                    apiResponse && (
                        <div className="api-response">
                            <div className='div-lab-tit'>
                                <h2>{apiResponse.data.etiqueta}</h2>
                            </div>
                            <div className='div-result-porcent'>
                                <h3>Tu pensamiento es:</h3>
                                <h2 className='txt-ama'>{Math.ceil(parseFloat(apiResponse.data.porcentaje_de_rs))}%</h2>
                                <h3>Similar al de Ricardo Salinas</h3>
                            </div>
                            <div className='div-result'>
                                <div className='div-recomnd'>
                                    <h4>Según tus resultados, esto podría interesarte:</h4>
                                    <div className='div-recomnd-list'>
                                        {apiResponse.data.links.map((linkPair, index) => {
                                            const [title, link] = linkPair;
                                            const variable = extractVariable(link);
                                            return (
                                                <div className='actv-card' key={index}>
                                                    <a target='_blank' href={link}><img src={variable} className='actv-card-poster' alt={title} /></a>
                                                    <p><a className='actv-card-link' target='_blank' href={link}>{title}</a></p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default Body;

{/* 
    const extractVariable = (link) => {
        if (link.includes("GUID=")) {
            return link.split("GUID=")[1].split("&")[0];
        } else if (link.includes("/blog/")) {
            return link.split("/blog/")[1].split("&")[0];
        } else if (link.includes("watch?v=")) {
            return link.split("watch?v=")[1].split("&")[0];
        } else if (link.includes("short/")) {
            return link.split("short/")[1].split("&")[0];
        } else {
            return "Formato no reconocido";
        }
    };
*/}

